import Ajax from '../common/ajax'
import ApiBase from './api-base'
import store from '../store'
import Tool from '../common/tool'
import Layout from '../components/layout'

export default {
  ...ApiBase,
  model: 'menu',
  allotMenu () {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/allotMenu`)
  },
  save (menuIds, buttonIds, roleId) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/bindMenu`, { menuIds, buttonIds, roleId })
  },
  getRoleInfo (roleId) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/list/${roleId}`)
  },
  getButtonInfo (roleId) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/listButton/${roleId}`)
  },
  getList () {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/listAll`)
  },
  getButtonList () {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/listAllButton`)
  },
  getRoleList () {
    return Ajax.get(`/api/gradeMaster/v1/role/listAll`)
  },
  getMenuRouter () {
    let list = []
    let currentUserInfo = store.state.currentUserInfo
    if (Tool.isNull(currentUserInfo.menuList)) {
      return []
    }
    Tool.walkTree(currentUserInfo.menuList, function (node) {
      list.push({ path: node.path, name: node.menuName, layout: Layout, isPage: Tool.isNull(node.children) || !!node.hideChildren })
    })
    let routeList = []
    for (let i in list) {
      let item = list[i]
      if (item.layout) {
        routeList.push({
          path: item.path,
          isPage: item.isPage,
          meta: { title: item.name },
          component: item.layout,
          redirect: item.path,
          children: [{
            path: item.path,
            name: item.name,
            meta: { title: item.name },
            component: () => import(/* webpackChunkName: "[request]" *//* webpackPrefetch: true */`../pages${item.path}`)
          }]
        })
      } else {
        routeList.push({
          path: item.path,
          isPage: item.isPage,
          name: item.name,
          meta: { title: item.name },
          component: () => import(/* webpackChunkName: "[request]" *//* webpackPrefetch: true */`../pages${item.path}`)
        })
      }
    }
    return routeList
  }
}
